import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import Axios from "@/lib/axios-instance";
import useOnboardingData from "@/store/onboarding-data";
import { useNavigate } from "react-router";

type APIPayload = {
    name: string;
};

type ResponseType = {
    data: any;
    meta: any;
};

export const createStore = async (payload: APIPayload) => {
    try {
        const response = await Axios.post("/users/create-store", payload);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(`${error.response.data?.meta?.message || "An error occurred"}`);
        }
        throw new Error(error.message || "Network Error");
    }
};

export const useCreateStore = () => {
    const { setIsStep1Complete, setStoreData } = useOnboardingData();
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    return useMutation<ResponseType, Error, APIPayload>({
        mutationFn: (payload: APIPayload) => createStore(payload),
        onSuccess: (data) => {
            queryClient.refetchQueries({ queryKey: ["check_user"] });
            setIsStep1Complete(true);
            setStoreData(data?.data?.store);
            navigate("/onboarding/step-2", { replace: true });
            toast.success("Store Creation Successful");
        },
        onError: (error) => {
            toast.error("Store Creation Failed", { description: error.message });
        },
    });
};
